const getHost = () => window.location.hostname;

export const isLocal = () => getHost().includes('localhost');

export const isDev = () => getHost().includes('dispatch-dev') || isLocal();

export const isStg = () => getHost().includes('dispatch-stg');

export const isProd = () => !isDev() && !isStg();
